// para obtener todas las PROVEEDORES tanto de planta como proveedores
export const GET_PROVEEDORES_LIST_SUCCESS = 'GET_PROVEEDORES_LIST_SUCCESS';
export const GET_PROVEEDORES_LIST_FAIL = 'GET_PROVEEDORES_LIST_FAIL';

export const GET_PROVEEDORES_SUCCESS = 'GET_PROVEEDORES_SUCCESS';
export const GET_PROVEEDORES_FAIL = 'GET_PROVEEDORES_FAIL';  

export const GET_PROVEEDORES_SEARCH_SUCCESS = 'GET_PROVEEDORES_SEARCH_SUCCESS';
export const GET_PROVEEDORES_SEARCH_FAIL = 'GET_PROVEEDORES_SEARCH_FAIL';